import _ from 'lodash'
import cx from 'classnames'
import React from 'react'
import T from 'prop-types'
import { ScrollBars } from 'react-base'
import { Editor, ContentState, EditorState } from 'draft-js'

/**
 * DraftJS based "textarea" component.
 * Benefits vs a TextInput in textarea mode:
 * - Auto-grows by default (can be given fixed height or max-height via CSS)
 * - Not user resizable
 * - Non-tooltip based validation message
 */

class TextareaInput extends React.Component {
  static displayName = 'TextareaInput'

  static propTypes = {
    className: T.string,
    initialValue: T.string,
    onChange: T.func, //passed (value, validationMsg, ...onChangeArgs)
    onChangeArgs: T.array,
    placeholder: T.string,
    readOnly: T.bool,
    spellCheck: T.bool,
    validator: T.func,
    onFocus: T.func,
    onBlur: T.func
  }

  static defaultProps = {
    spellCheck: true
  }

  constructor(props) {
    super(props)
    this.state = {
      editorState: this.getNewEditorState(props),
      hasFocus: false,
      validationMsg: null,
      value: props.initialValue || ''
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { initialValue } = this.props
    const { value } = this.state
    if (
      nextProps.initialValue !== initialValue &&
      nextProps.initialValue !== value
    ) {
      this.setState({
        editorState: this.getNewEditorState(nextProps)
      })
    }
  }

  getNewEditorState = props => {
    const { initialValue } = props
    return EditorState.createWithContent(
      ContentState.createFromText(!initialValue ? '' : initialValue)
    )
  }

  emitChange = (value, validationMsg) => {
    const { onChange, onChangeArgs = [] } = this.props
    onChange(value, validationMsg, ...onChangeArgs)
  }

  handleEditorChange = editorState => {
    const { validator } = this.props
    const value = editorState
      .getCurrentContent()
      .getPlainText()
      .trim()
    const validationMsg = validator && validator(value)
    this.setState({
      editorState: editorState,
      value,
      validationMsg
    }, () => {
      this.emitChange(value, validationMsg)
    })
  }

  _handleFocus = () => {
    this.setState({
      hasFocus: true
    })
    const handler = this.props.onFocus
    if (handler) handler()
  }

  _handleBlur = () => {
    this.setState({
      hasFocus: false
    })
    const handler = this.props.onBlur
    if (handler) handler()
  }

  render() {
    const {
      className,
      readOnly,
      placeholder,
      spellCheck,
    } = this.props
    const {
      editorState,
      validationMsg,
      hasFocus
    } = this.state

    return (
      <div
        className={cx(`textarea_input`, className, {
          editable: !readOnly,
          read_only: readOnly,
          invalid: !!validationMsg,
          has_focus: !!hasFocus
        })}
        data-tooltip={validationMsg}
      >
        {validationMsg ? (
          <div className="invalid_msg">{validationMsg}</div>
        ) : null}
        <ScrollBars>
          <Editor
            editorState={editorState}
            onChange={this.handleEditorChange}
            placeholder={placeholder}
            readOnly={readOnly}
            spellCheck={spellCheck}
            onFocus={this._handleFocus}
            onBlur={this._handleBlur}
            stripPastedStyles
          />
        </ScrollBars>
      </div>
    )
  }
}

export default TextareaInput
